module.exports = __webpack_public_path__ + "static/media/forsta.1047c866.m4a";